<template>
    <div>

        <div class="ckEditorWrapper" :id="elementId">

        </div>

    </div>
</template>
<script>
export default {
    name: 'CkEditor',
    data() {
        return {
            elementId: `ckeditor_${this._uid}`,
            editor: null
        }
    },
    mounted() {
        this.initEditor();
    },
    methods: {

        getData(){
            return this.editor.getData();
        },

        setData(data){
            this.editor.setData(data);
        },

        //inserts plain text at the caret (or replaces the selection)
        insertText(text){

            if (!this.editor || !text)
                return;

            this.editor.model.change(writer => {
                this.editor.model.insertContent(writer.createText(text), this.editor.model.document.selection);
            });

            this.editor.editing.view.focus();
        },

        initEditor() {
            CKEDITOR.ClassicEditor.create(document.getElementById(this.elementId), {
                // https://ckeditor.com/docs/ckeditor5/latest/features/toolbar/toolbar.html#extended-toolbar-configuration-format


                language: {
                    content: 'he'
                },

                toolbar: {
                    items: [
                        // 'heading', '|',
                        '|',
                        'bold', 'italic', 'strikethrough', 'underline', '|',
                        'bulletedList', 'numberedList', 'todoList', '|',
                        'indent', 'outdent', '|',
                        'undo', 'redo', '|',
                        'fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', '|',
                        'alignment', '|',
                        'insertImage', 'insertTable',
                        // '|', 'horizontalLine', 'pageBreak', '|',
                    ],
                    shouldNotGroupWhenFull: true
                },
                // Changing the language of the interface requires loading the language file using the <script> tag.
                // language: 'es',
                list: {

                    properties: {
                        styles: true,
                        startIndex: true,
                        reversed: true
                    }
                },
                // https://ckeditor.com/docs/ckeditor5/latest/features/headings.html#configuration
                heading: {
                    options: [
                        { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                        { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                        { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                        { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                        { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                        { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                    ]
                },
                // https://ckeditor.com/docs/ckeditor5/latest/features/editor-placeholder.html#using-the-editor-configuration
                placeholder: '',
                // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-family-feature
                fontFamily: {
                    options: [
                        'default',
                        'Arial, Helvetica, sans-serif',
                        'Courier New, Courier, monospace',
                        'Georgia, serif',
                        'Lucida Sans Unicode, Lucida Grande, sans-serif',
                        'Tahoma, Geneva, sans-serif',
                        'Times New Roman, Times, serif',
                        'Trebuchet MS, Helvetica, sans-serif',
                        'Verdana, Geneva, sans-serif'
                    ],
                    supportAllValues: true
                },
                // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#configuring-the-font-size-feature
                fontSize: {
                    options: [10, 12, 14, 16, 18, 20, 22],
                    supportAllValues: true
                },
                // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
                // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
                htmlSupport: {
                    allow: [
                        {
                            name: /.*/,
                            attributes: true,
                            classes: true,
                            styles: true
                        }
                    ]
                },
                // Be careful with enabling previews
                // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
                htmlEmbed: {
                    showPreviews: true
                },
                // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
                link: {
                    decorators: {
                        addTargetToExternalLinks: true,
                        defaultProtocol: 'https://',
                        toggleDownloadable: {
                            mode: 'manual',
                            label: 'Downloadable',
                            attributes: {
                                download: 'file'
                            }
                        }
                    }
                },

                // The "super-build" contains more premium features that require additional configuration, disable them below.
                // Do not turn them on unless you read the documentation and know how to configure them and setup the editor.
                removePlugins: [
                    // These two are commercial, but you can try them out without registering to a trial.
                    'ExportPdf',
                    'ExportWord',
                    'CKBox',
                    'CKFinder',
                    'EasyImage',
                    // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                    // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                    // Storing images as Base64 is usually a very bad idea.
                    // Replace it on production website with other solutions:
                    // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                    // 'Base64UploadAdapter',
                    'RealTimeCollaborativeComments',
                    'RealTimeCollaborativeTrackChanges',
                    'RealTimeCollaborativeRevisionHistory',
                    'PresenceList',
                    'Comments',
                    'TrackChanges',
                    'TrackChangesData',
                    'RevisionHistory',
                    'Pagination',
                    'WProofreader',
                    // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                    // from a local file system (file://) - load this site via HTTP server if you enable MathType.
                    'MathType',
                    // The following features are part of the Productivity Pack and require additional license.
                    'SlashCommand',
                    'Template',
                    'DocumentOutline',
                    'FormatPainter',
                    'TableOfContents'
                ]

            }).then((newEditor) => {
                this.editor = newEditor;
                this.$emit('ready');
            });
        }

    }

}
</script><style>



.hideToolbar .ck-editor__top{
    opacity: 0 !important;
    pointer-events: none !important;
}
.ck-editor__top {
    position: sticky !important;
    top: 90px !important;
    z-index: 100 !important;
    margin: 30px auto !important;
    width: 860px !important;

}



.ck-toolbar{
    border: none !important;
}


.ck-content{
    aspect-ratio: 0.7072;
    border: solid 1px #ced4da !important;
    border-radius:6px !important;
    
}


.ck-editor__editable_inline{
    width: 816px !important;
    margin: 30px auto;
    padding: 2.7% !important;
}



.ck.ck-sticky-panel .ck-sticky-panel__content_sticky {
  position: unset !important;
  top: unset !important;
}


.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){
    border: solid 1px #ab8ce4 !important;
    outline: none !important;
    box-shadow: 0px 0px 4px 4px #ab8ce4 !important;
}

.ck-sticky-panel__placeholder{
    display: none !important;
}

ck-sticky-panel__content{
    width: 100% !important;
}

[data-cke-tooltip-text="Increase indent"], [data-cke-tooltip-text="Decrease indent"]{
        transform: rotate(180deg);
    }



</style>